import { render } from "./Home.vue?vue&type=template&id=9797cf4e"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=9797cf4e&lang=postcss"
script.render = render

export default script